// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
// 引入公共组件editor
// import UE from '../public/ue.vue';
import VueUeditorWrap from 'vue-ueditor-wrap';
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  // ===========================  ueditor  使用代码 start   ================
  // components: {UE},
  components: {
    VueUeditorWrap,
  },
  data() {
    return {
      myConfig: {
        // 如果需要上传功能,找后端小伙伴要服务器接口地址
        serverUrl: 'https://api.guanchao.site/Editor/php/controller.php',
        // serverUrl: 'https://xxx.xxx.site/Editor/php/controller.php',
        // 你的UEditor资源存放的路径,相对于打包后的index.html
        UEDITOR_HOME_URL: '/Editor/',
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 关闭自动保存
        enableAutoSave: false,
      },
      defaultMsg: '', // 默认显示的文字
      config: {
        initialFrameWidth: 1200,
        initialFrameHeight: 350,
      },
      ue1: 'ue1', // 不同编辑器必须不同的id
      ueState: false, // ue状态
      //= ============================   ueidtor  使用代码  end   ================
      articletitle: '', // 面包屑导航显示标题
      arttitle: '', // 文章标题
      another: '', // 作者
      // cid:'',//文章分类
      model1: '', // 文章分类
      artdesc: '', // 文章描述
      artlogo: '', // 文章图片
      status: 1, // 文章状态
      categorylist: '', // 分类列表
      artid: '', // 文章id
      content: '', // 文章内容
      articleinfo: '', // 文章信息
      labellist: '', // 标签列表
      labelstr: '', // 标签值
      labellistedit: '', // 已选中的标签
      page: '', // 页码
      search: '', // 搜做条件
      resourse_id: '', // 资源id
      resourcelist: '', // 资源列表
    };
  },
  created() {
    const artid = this.$route.query.artid;
    const spage = this.$route.query.page;
    this.search = this.$route.query.search;
    if (spage == undefined) {
      this.page = 1;
    } else {
      this.page = spage;
    }
    const self = this;
    if (artid) {
      this.articletitle = '修改文章';
      self.ueState = false;
    } else {
      this.articletitle = '添加文章';
      self.ueState = true;
    }
    axios({
      method: 'post',
      url: '/admin/Article/editArticle',
      data: { id: artid },
    })
      .then((response) => {
        checkRule(response, self); // 检查是否有权限
        self.categorylist = response.data.categorylist;
        self.labellist = response.data.labellist;
        self.resourcelist = response.data.resourcelist;
        if (artid) {
          self.articleinfo = response.data.articleinfo;
          self.arttitle = response.data.articleinfo.arttitle;
          self.another = response.data.articleinfo.another;
          self.artdesc = response.data.articleinfo.artdesc;
          self.artlogo = response.data.articleinfo.artlogo;
          self.status = response.data.articleinfo.status;
          self.defaultMsg = response.data.articleinfo.content;
          self.ueState = true; // 控制ueditor和select是否加载
          self.model1 = response.data.articleinfo.art_cid;
          self.artid = response.data.articleinfo.id;
          self.labelstr = response.data.articleinfo.labelstr;
          self.resourse_id = response.data.articleinfo.resourse_id;
          // self.labelstr = [2, 3, 5, 7, 8, 12];
        } //* /
      })
      .catch((response) => {
        // self.$Message.error('请求失败');
      });

    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 1000);
  },
  methods: {
    // 图片上传回调钩子方法
    handleSuccess(response) {
      checkRule(response, this); // 检查是否有权限
      if (response.code == 1) {
        this.artlogo = response.imgpath;
        this.$Message.success('图片上传成功');
      } else {
        this.$Message.error('图片上传失败');
      }
    },
    // ===========================  ueditor  使用代码 start   ================
    // 获取子组件中ueidtor的值（含html标签）
    // ref 被用来给元素或子组件注册引用信息。引用信息将会注册在父组件的 $refs 对象上。
    // 如果在普通的 DOM 元素上使用，引用指向的就是 DOM 元素；如果用在子组件上，引用就指向组件实例：
    // getUEContent() {
    //   let content = this.$refs.ue.getUEContent(); // 调用子组件方法
    //   console.log(content)
    // },
    // 获取子组件中ueidtor的值（不含html标签）
    // getUEContentTxt() {
    //   let content = this.$refs.ue.getUEContentTxt(); // 调用子组件方法
    //   console.log(content)
    // },
    //= ============================   ueidtor  使用代码  end   ================
    // 文章提交方法
    putArticle() {
      // this.content = this.$refs.ue.getUEContent(); // 调用子组件方法
      console.log(this.resourse_id);
      const self = this;
      axios({
        method: 'post',
        url: '/admin/Article/updateArticle',
        data: {
          arttitle: self.arttitle,
          another: self.another,
          art_cid: self.model1,
          artlogo: self.artlogo,
          artdesc: self.artdesc,
          status: self.status,
          content: self.defaultMsg,
          artid: self.artid,
          labelstr: self.labelstr,
          resourse_id: self.resourse_id,
        },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
            self.$router.push({
              path: '/article', // 这是路由名称
              query: { page: self.page, search: self.search },
            });
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        });
    },
  },
};
